var ReleaseSeatsConfirmScreen = (function ($) {

    ReleaseSeatsConfirmScreen = function (options) {
        var that = this;

        options = options || {};

        // CONST
        that.order_hash = options['order_hash'] || null;
        that.order_passenger_hash = options['order_passenger_hash'] || null;
        that.modals = options['modals'] || {};
        that.locales = options['locales'] || {};
        that.order_url = options['order_url'];

        that.is_show_order_contact_data_modal = options['is_show_order_contact_data_modal'];

        that.final_order_hash = null;
        that.final_order_passenger_hash = null;
        that.final_order_pnr = null;
        that.final_order_url = null;

        that.attribute = {
            disabled: 'disabled'
        }
        that.class = {
            error: 'error',
            hidden: 'hidden',
            disabled: 'disabled'
        };
        that.selectors = {
            confirm_content: '.js-confirm-content',
            warning_wrapper: '.js-release-seats-warning-wrapper',
            release_seats_completed: '.js-release-seats-completed',

            divided_order_card: '.js-divided-order-card',
            divided_order_link: '.js-divided-order-link',
            divided_order_pnr: '.js-divided-order-pnr',

            confirm_terms_wrapper: '.js-confirm-terms-wrapper',
            confirm_terms: '.js-confirm-terms',
            confirm_terms_tooltip_warning: '.js-confirm-terms-tooltip-warning',
            confirm_terms_tooltip_warning_checkbox: '.js-confirm-terms-tooltip-warning-checkbox',

            fareremark_info: '.js-fareremark-info'
        };

        // DYNAMIC VARS
        that.screen_is_locked = false;
        that.is_confirm = false;
        that.data = {};
        that.order_contact_data = {};

        // HANDLERS
        that.onValid = (options['onValid'] || false);
        that.onConfirm = (options['onConfirm'] || false);

        // DOM
        that.$wrapper = options['$wrapper'];
    };

    ReleaseSeatsConfirmScreen.prototype.init = function (data) {
        var that = this,
            deferred = $.Deferred();

        that.__getConfirm(data).done(function (response) {
            if (true === response) {
                that.data = data;
                that.__initEvents();

                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }).fail(function (error) {
            deferred.reject(error);
        });

        return deferred.promise();
    };

    ReleaseSeatsConfirmScreen.prototype.isValid = function () {
        var that = this;

        if (!that.$confirm_terms_checkbox.prop('checked')) {
            that.__toggleConfirmTermsTooltip('show');
            return false;
        }

        return true;
    };

    ReleaseSeatsConfirmScreen.prototype.getData = function () {
        return {};
    };

    /**
     * @private
     */
    ReleaseSeatsConfirmScreen.prototype.__initEvents = function () {
        var that = this;

        that.__initConfirmTerms();

        that.__initFareremark();
    };

    /**
     * @private
     */
    ReleaseSeatsConfirmScreen.prototype.__getConfirm = function (data) {
        var that = this,
            deferred = $.Deferred(),
            confirm_url = that.order_url + '/releaseseats/confirm';

        $.get(confirm_url, data).done(function (response, textStatus, jqXHR) {
            if (200 === jqXHR.status && response.length) {
                that.$wrapper.html(response);
                that.$confirm_content = that.$wrapper.find(that.selectors.confirm_content);
                that.$warning_wrapper = that.$wrapper.find(that.selectors.warning_wrapper);
                that.$release_seats_completed = that.$confirm_content.find(that.selectors.release_seats_completed);

                that.$fareremark_info = that.$confirm_content.find(that.selectors.fareremark_info);

                that.$divided_order_card = that.$confirm_content.find(that.selectors.divided_order_card);
                that.$divided_order_link = that.$divided_order_card.find(that.selectors.divided_order_link);
                that.$divided_order_pnr = that.$divided_order_card.find(that.selectors.divided_order_pnr);

                that.$confirm_terms_wrapper = that.$wrapper.find(that.selectors.confirm_terms_wrapper);
                that.$confirm_terms_checkbox = that.$confirm_terms_wrapper.find(that.selectors.confirm_terms);
                that.$confirm_terms_tooltip = that.$confirm_terms_wrapper.find(that.selectors.confirm_terms_tooltip_warning);
                that.$confirm_terms_tooltip_checkbox = that.$confirm_terms_wrapper.find(that.selectors.confirm_terms_tooltip_warning_checkbox);

                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }).fail(function (error) {
            deferred.reject(error);
        });

        return deferred.promise();
    };

    /**
     * @private
     */
    ReleaseSeatsConfirmScreen.prototype.confirmReleaseSeats = function (data) {
        var that = this,
            deferred = $.Deferred();

        if (!that.is_confirm) {
            that.__showConfirmModal();
            deferred.resolve('action_confirmed');
            return deferred.promise();
        }

        if (that.is_show_order_contact_data_modal && $.isEmptyObject(that.order_contact_data)) {
            that.__showOrderContactDataModal();
            deferred.resolve('contact_data_validated');
            return deferred.promise();
        }

        that.__initReleaseSeatsPerform(data).done(function (response) {
            deferred.resolve(true === response);
        }).fail(function () {
            deferred.resolve(false);
        });

        return deferred.promise();
    };

    /**
     * @private
     */
    ReleaseSeatsConfirmScreen.prototype.__initReleaseSeatsPerform = function (data) {
        var that = this,
            href = $.sa.build_url('order/releaseseats/perform'),
            deferred = $.Deferred();

        $.extend(data, {
            order_hash: that.order_hash,
            order_passenger_hash: that.order_passenger_hash,
            recipient_email: that.order_contact_data.email || null,
            recipient_phone: that.order_contact_data.phone || null
        });

        $.post(href, data, function (response) {
            if (typeof response !== 'object') {
                response = {
                    status: 'fail',
                    errors: [
                        {
                            code: 0,
                            message: $.sa.locales['something_went_wrong'],
                        }
                    ],
                };
            }

            switch (response.status) {
                case 'ok':
                    that.__handleReleaseSeatsSuccess(response);
                    deferred.resolve(true);
                    break;
                case 'fail':
                    that.__handleReleaseSeatsError();
                    deferred.resolve(false);
                    break;
            }
        }).fail(function (error) {
            that.__handleReleaseSeatsError();
            deferred.reject(error);
        });

        return deferred.promise();
    };

    /**
     * @param response
     * @private
     */
    ReleaseSeatsConfirmScreen.prototype.__handleReleaseSeatsSuccess = function (response) {
        var that = this;

        that.final_order_pnr = response.data['pnr'];
        that.final_order_hash = response.data['order_hash'];
        that.final_order_passenger_hash = response.data['order_passenger_hash'];
        that.final_order_url = response.data['order_url'];

        that.$warning_wrapper.toggleClass(that.class.hidden);
        that.$release_seats_completed.toggleClass(that.class.hidden);
        that.$confirm_terms_wrapper.toggleClass(that.class.hidden);

        if (that.order_hash !== that.final_order_hash) {
            that.$divided_order_card.removeClass(that.class.hidden);
            that.$divided_order_link.attr('href', that.final_order_url);
            that.$divided_order_pnr.text(that.final_order_pnr);
        }

        if (typeof that.onConfirm === 'function') {
            that.onConfirm();
        }
    };

    /**
     * @private
     */
    ReleaseSeatsConfirmScreen.prototype.__handleReleaseSeatsError = function () {
        var that = this;

        $.uiModal({
            html: that.modals['release_seats_error'],
            esc: false,
            close_on_avia_before_load: false,
            onBgClick: function (modal, event) {
                event.preventDefault();
                return false;
            },
            onClose: function () {
                $.sa.content_router.load((that.final_order_url ? that.final_order_url : that.order_url));
            }
        });
    };

    /**
     * @private
     */
    ReleaseSeatsConfirmScreen.prototype.__showConfirmModal = function () {
        var that = this;

        $.sa.confirm.show({
            title: that.locales['confirm_modal']['title'],
            content: that.locales['confirm_modal']['content'],
            button_cancel: that.locales['confirm_modal']['cancel'],
            onConfirm: function () {
                that.is_confirm = true;
            },
            onClose: function () {
                if (that.is_confirm === true && typeof that.onValid === 'function') {
                    that.onValid();
                }
            }
        });
    };
    
    /**
     * @private
     */
    ReleaseSeatsConfirmScreen.prototype.__showOrderContactDataModal = function () {
        var that = this;

        new OrderContactDataForm({
            modal: that.modals['order_contact_data'],
            onClose: function (is_valid, order_contact_data) {
                if (is_valid) {
                    that.order_contact_data = order_contact_data;
                    if (typeof that.onValid === 'function') {
                        that.onValid();
                    }
                }
            }
        });
    };

    /**
     * @param state
     * @private
     */
    ReleaseSeatsConfirmScreen.prototype.__toggleConfirmTermsTooltip = function (state) {
        var that = this;

        if (state === 'show') {
            that.$confirm_terms_tooltip.css('opacity', '1');
            that.$confirm_terms_tooltip_checkbox.addClass(that.class.error);
        }

        if (state === 'hide') {
            that.$confirm_terms_tooltip.removeAttr('style');
            that.$confirm_terms_tooltip_checkbox.removeClass(that.class.error);
        }
    };

    ReleaseSeatsConfirmScreen.prototype.__initConfirmTerms = function () {
        var that = this;

        that.$confirm_terms_checkbox.on('change', function () {
            var checked = $(this).prop('checked');
            if (checked) {
                that.__toggleConfirmTermsTooltip('hide');
            }

            that.$confirm_terms_checkbox.prop('checked', checked);
        });
    };

    ReleaseSeatsConfirmScreen.prototype.__initFareremark = function () {
        var that = this;

        that.$fareremark_info.on('click', function () {
            if (that.screen_is_locked) {
                return;
            }

            var data;
            if (that.final_order_hash) {
                data = {
                    order_hash: that.final_order_hash
                }
            } else {
                data = that.data;
                data.order_hash = that.order_hash;
                if (that.order_passenger_hash) {
                    data.order_passenger_hash = that.order_passenger_hash;
                }
            }

            $.uiFareremark(data);
        });
    };

    // EVENTS
    ReleaseSeatsConfirmScreen.prototype.beforeUnload = function () {
        var that = this;

        that.screen_is_locked = true;
        that.$fareremark_info.addClass(that.class.disabled);
        that.$confirm_terms_checkbox.attr(that.attribute.disabled, true);
    };

    ReleaseSeatsConfirmScreen.prototype.afterLoad = function () {
        var that = this;

        that.screen_is_locked = false;
        that.$fareremark_info.removeClass(that.class.disabled);
        that.$confirm_terms_checkbox.attr(that.attribute.disabled, false);
    };

    return ReleaseSeatsConfirmScreen;
})($);
